import SET_MARKETPLACE_SPS from 'constants/marketplace';

const initialState = { marketplaceSPS: [] };

const marketplace = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_MARKETPLACE_SPS.SUCCESS:
      return {
        marketplaceSPS: [...payload],
      };
    default:
      return state;
  }
};

export const getMarketplaceSPS = state =>
  state.configs.marketplace.marketplaceSPS;

export default marketplace;
